// extracted by css-extract-rspack-plugin
export default {"CollectionLink":"DashboardMoveModal-module__CollectionLink___o9lF0"};